import React, { useRef, useState, useEffect } from 'react';
import { stats } from '../data/mockData';

const StatsSection = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.3 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <section
      ref={sectionRef}
      className="py-20 relative overflow-hidden"
      style={{
        background: 'linear-gradient(135deg, #fafafa 0%, #f5f5f5 50%, #efefef 100%)'
      }}
    >
      {/* Subtle Pattern */}
      <div className="absolute inset-0 opacity-30" style={{
        backgroundImage: `radial-gradient(circle at 2px 2px, rgba(0,0,0,0.03) 1px, transparent 0)`,
        backgroundSize: '32px 32px'
      }} />

      <div className="max-w-7xl mx-auto px-6 lg:px-8 relative z-10">
        <div className={`flex justify-center items-center gap-12 lg:gap-24 transform transition-all duration-1000 ${
          isVisible ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'
        }`}>
          {stats.map((stat, index) => (
            <div
              key={index}
              className="text-center group"
              style={{ transitionDelay: `${index * 150}ms` }}
            >
              <div className="relative">
                <h3 className="text-5xl lg:text-7xl xl:text-8xl font-extrabold text-gray-900 mb-3 group-hover:scale-105 transition-transform duration-500">
                  {stat.value}
                </h3>
              </div>
              <p className="text-gray-500 text-base lg:text-lg font-medium">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default StatsSection;
